import { RouteObject } from 'react-router-dom'

import ProtectedRoute from '@/components/Router/ProtectedRoute'

import chargingPointPageLoader from '@/pages/ChargingPoint/loader'
import ChargingPointPage from '@/pages/ChargingPoint'

import WalletPage from '@/pages/Wallet'
import CardAdd from '@/pages/Card/Add'
import ProfilePage from '@/pages/Profile'

import { AppRoutes } from './types/routes'

export const protectedRoutes: RouteObject = {
  element: <ProtectedRoute />,
  children: [
    {
      path: AppRoutes.CHARGING_POINT,
      element: <ChargingPointPage />,
      loader: chargingPointPageLoader,
    },
    { path: AppRoutes.WALLET, element: <WalletPage /> },
    {
      path: AppRoutes.CARD_ADD,
      element: <CardAdd />,
    },
    { path: AppRoutes.PROFILE, element: <ProfilePage /> },
  ],
}
